module.exports = __webpack_public_path__ + "img/TF.65249db0.svg";